import moment from "moment";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import submit from "submit-form";
import { validateSchedule } from "../../../utils/questionnaire-validations";
import { getCheckInSchedule } from "../../../utils/questionnaire";
import Modal from "../../modal-new";
import SvgIcon from "../../SvgIcon";

const frenquencyChecks = [
  // { displayText: "Daily", value: "daily" },
  { displayText: "Weekly", value: "weekly" },
  { displayText: "Bi-Weekly", value: "biweekly" },
  { displayText: "Monthly", value: "monthly" },
];

const QuestionnaireSchedule = (
  { startingCalendarDay, athlete, userToLoadInformation },
  { locals }
) => {
  const { _id: athleteId } = athlete;
  const schedule = getCheckInSchedule(athlete);
  const { assert, flash } = locals;

  const [currentFrequency, setCurrentFrequency] = useState(
    schedule ? schedule.frequency : ""
  );
  const [currentWeekDay, setCurrentWeekDay] = useState(
    schedule ? schedule.dayOfWeek : ""
  );

  // Gets an array of the weekdays according to the starting calendar day.
  const defaultWeekdays = Array.apply(null, Array(7)).map((_, i) => {
    return moment(i, "e")
      .startOf("week")
      .isoWeekday(i + startingCalendarDay)
      .format("dddd")
      .slice(0, 3)
      .toLowerCase();
  });

  // Gets an array with false using the defaultWeekdays array
  const initSelectedWeeklyDays = defaultWeekdays.map((day) => ({
    day,
    active: false,
  }));

  const [selectedWeeklyDays, setSelectedWeeklyDays] = useState(
    schedule && schedule.selectedWeeklyDays
      ? schedule.selectedWeeklyDays
      : initSelectedWeeklyDays
  );

  const [startCheckInDay, setStartCheckInDay] = useState(
    schedule ? moment(String(schedule.startDay)) : null
  );

  const handleFrequencyClick = (value) => {
    setCurrentFrequency(value);
  };

  const handleWeekDayClick = (value, index) => {
    setCurrentWeekDay(value);

    handleCheckInDay(index);
  };

  const handleCheckInDay = (index) => {
    const today = moment();
    const dayOfTheWeek = moment()
      .startOf("week")
      .add(startingCalendarDay + index, "days");

    if (today.isSameOrAfter(dayOfTheWeek)) {
      setStartCheckInDay(moment(dayOfTheWeek).add(7, "days"));
    } else {
      setStartCheckInDay(moment(dayOfTheWeek));
    }
  };

  // Daily check in useEffect
  // useEffect(() => {
  //   const firstActiveDay = selectedWeeklyDays.findIndex((day) => day.active);

  //   handleCheckInDay(firstActiveDay);
  // }, [selectedWeeklyDays]);

  const handleWeeklyDayClick = (value, index) => {
    setSelectedWeeklyDays((prevState) =>
      prevState.map((obj) => {
        if (obj.day === value) {
          return { day: value, active: !obj.active };
        }

        return obj;
      })
    );

    handleCheckInDay(index);
  };

  const handleSetSchedule = () => {
    const newSchedule = {
      dayOfWeek: currentWeekDay,
      startDay: startCheckInDay
        ? Number(moment(startCheckInDay).format("YYYYMMDD"))
        : 0,
      frequency: currentFrequency,
      selectedWeeklyDays,
    };

    if (validateSchedule(newSchedule, assert, flash)) {
      submit("/actions/questionnaire/add-schedule", {
        method: "POST",
        body: {
          schedule: newSchedule,
          athleteId,
          // no need to pass the organization owner since it only works with
          // the coach's athlete information (not templates or whatever)
          userToRequest: userToLoadInformation._id,
        },
      });
    }
  };

  return (
    <Modal
      width={"45%"}
      title={"SCHEDULE CHECK-IN"}
      className={"questionnaire-schedule-modal"}
    >
      <div className="body">
        <section className="schedule-frequency">
          <h5>Frequency:</h5>
          {frenquencyChecks.map((frequency) => (
            <div
              className="frequency-item"
              key={frequency.value}
              onClick={() => {
                handleFrequencyClick(frequency.value);
              }}
            >
              <SvgIcon
                src={
                  currentFrequency === frequency.value
                    ? "/img/new-icons/tick-circle.svg"
                    : "/img/new-icons/radio-unchecked.svg"
                }
                noFilterOnLight={
                  currentFrequency === frequency.value ? true : false
                }
              />
              <p className="p5">{frequency.displayText}</p>
            </div>
          ))}
        </section>
        <section className="schedule-weekday">
          <h5>
            {currentFrequency === "daily"
              ? "Select the days of the week"
              : "Select a day of the week"}
          </h5>
          <div className="schedule-weekdays">
            {defaultWeekdays.map((weekDay, index) => (
              <div
                key={weekDay}
                className={
                  currentWeekDay === weekDay
                    ? "p4 accountability-day active"
                    : "p4 accountability-day"
                }
                onClick={() => {
                  currentFrequency === "daily"
                    ? handleWeeklyDayClick(weekDay, index)
                    : handleWeekDayClick(weekDay, index);
                }}
              >
                {weekDay.slice(0, 1).toUpperCase()}
              </div>
            ))}
          </div>
        </section>

        {startCheckInDay && (
          <h5>
            The client will see the report for the first time on{" "}
            {startCheckInDay.format("MMM D, YYYY")}
          </h5>
        )}
      </div>
      <footer>
        <a
          href="/actions/refresh?modal=&undefined="
          role="button"
          data-button-type="secondary"
          data-action="cancel"
        >
          Cancel
        </a>
        <button onClick={handleSetSchedule} data-button-type="primary">
          Save
        </button>
      </footer>
    </Modal>
  );
};

QuestionnaireSchedule.contextTypes = { locals: PropTypes.object };

export default QuestionnaireSchedule;
